export default __webpack_public_path__ + "static/media/404.651bfd32.png";